import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DetailProxyComponent from "../../../components/Customer/proxies/DetailProxyComponent";

const DetailProxyPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <DetailProxyComponent
        serviceId={ params.serviceId }
        redirectBack={ () => redirectBack() }
    />;
}

export default DetailProxyPage;